import { CustomModulesIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/_jsx(CustomModulesIcon, {
  size: "300"
});